export default{
  data() {
      return {
      }
  },
  props:{
      show: false,//是否显示轨迹抽屉
      instKey:null,//实例主键
      bizKey:null,//业务主键
  },
  methods: {
      loadTracks(){
          const me = this, list = me.$refs['track_list'];
          list.loadTracks();
      },
      toClose(){//发出关闭指令
        this.$emit('close', null, this);
      }
  },
}


// WEBPACK FOOTER //
// ./src/components/base/view/wf/exec/cmps/track/drawer/src/drawer.js